<template>
  <div>
    <TeSetWebengineerJobchangeCover :pack="pack" />

    <TeCommonPagenav>
      <template #coursename>
        Webエンジニア転職保証コース
      </template>
      <template #menu>
        <li>
          <a
            class="block px-4 py-3 text-co-gray-700 hover:text-co-gray-700"
            :href="'#about'"
            @click.prevent="scrollTo('about')"
          >
            概要
          </a>
        </li>
        <li>
          <a
            class="block px-4 py-3 text-co-gray-700 hover:text-co-gray-700"
            :href="'#price'"
            @click.prevent="scrollTo('price')"
          >
            料金
          </a>
        </li>
        <li>
          <a
            class="block px-4 py-3 text-co-gray-700 hover:text-co-gray-700"
            :href="'#flow'"
            @click.prevent="scrollTo('flow')"
          >
            受講の流れ
          </a>
        </li>
        <!-- 251202導線削除 -->
        <!-- <li>
          <a
            class="block px-4 py-3 text-co-gray-700 hover:text-co-gray-700"
            :href="'#faq'"
            @click.prevent="scrollTo('faq')"
          >
            FAQ
          </a>
        </li> -->
      </template>
    </TeCommonPagenav>

    <!-- 受講料最大70%OFFバナー -->
    <section class="co-bg-striped">
      <div class="co-container-sm px-4 py-5 text-center">
        <img
          class="mx-auto w-full max-w-[35.75rem]"
          src="~/assets/images/Te/TeSet/WebengineerJobchange/reskilling-cashback.webp"
          alt="受講料最大70%OFF 558,600円キャッシュバック"
        >
      </div>
    </section>

    <!-- 無料相談割引コード -->
    <TeCommonBannerTimeLimitCpnCode
      v-if="BannerNameForShowing === 'campaign'"
      :entry-campaign="entryCampaign"
    />

    <TeCommonBannerSettlement
      v-if="BannerNameForShowing === 'settlement'"
      :entry-settlement-time-limit="entrySettlementTimeLimit"
      :entry-payment-url="entryPaymentUrl"
    />

    <TeCommonBannerTimelimit
      v-if="BannerNameForShowing === 'discount'"
      :entry-discount-time-limit="entryDiscountTimeLimit"
    />

    <TeCommonBannerCampaign
      :course-name-path="packScreenName"
      :current-promotion="currentPromotion"
    />

    <!-- About -->
    <TeSetAbout>
      <template #title>
        <span class="co-display-6 font-bold">Webエンジニア<br class="md:hidden">転職保証コースについて</span>
      </template>
      <template #text>
        前職不問・プログラミング未経験の初心者でも
        <br class="hidden md:block">
        IT企業へ
        <span class="font-bold">Webエンジニアとして転職を目指せるコース</span>
        です。
        <br class="hidden md:block">
        専属の現役エンジニアとキャリアカウンセラーが学習から転職まで徹底サポートします。
        <br class="hidden md:block">
        受講終了後に転職が決まらなかった場合、
        <span class="font-bold">受講料を全額返金する保証制度</span>
        もございます。
      </template>
    </TeSetAbout>

    <!-- こんな方にオススメです -->
    <section
      id="target"
      class="te-bg-set-target bg-cover"
    >
      <div class="co-container-sm px-5 py-[3.25rem] text-center">
        <h2 class="co-display-6 mb-10 font-bold tracking-normal text-white">
          こんな方にオススメです
        </h2>
        <div class="mb-7 flex flex-col justify-center gap-7 md:flex-row">
          <div class="te-target-text w-full bg-white p-1 font-bold">
            未経験からWebエンジニアを目指したい方
          </div>
          <div class="te-target-text w-full bg-white p-1 font-bold">
            今の仕事からキャリアチェンジしたい方
          </div>
        </div>
        <div class="flex flex-col justify-center gap-7 md:flex-row">
          <div class="te-target-text w-full bg-white p-1 font-bold">
            これから正社員として働きたい方
          </div>
          <div class="te-target-text w-full bg-white p-1 font-bold">
            一生使えるスキルを身につけたい方
          </div>
        </div>
      </div>
    </section>

    <!-- CTA -->
    <!-- 251202導線削除 -->
    <!-- <TeCommonBannerFreeTrial id="cta-first">
      <template #counselingLead>
        当コースついてカウンセラーがご案内します
      </template>
    </TeCommonBannerFreeTrial> -->

    <!-- 2つのサポート -->
    <section class="co-bg-striped">
      <div class="co-container-sm px-4 py-20">
        <h2 class="co-heading-2-caption">
          転職成功に導く<br class="block md:hidden">2つのサポート
        </h2>
        <h3 class="co-display-12 mb-[3.25rem] leading-normal text-co-gray-600 md:text-center">
          現役エンジニアのパーソナルメンターとキャリアカウンセラーが
          <br class="hidden md:block">
          あなたの転職が決まるまで専属でサポートします。
        </h3>
        <div class="px-10 md:px-0">
          <img
            class="hidden md:block"
            src="~/assets/images/Te/TeSet/WebengineerJobchange/Support/photo-pc-support.webp"
            alt="サポート内容"
            loading="lazy"
          >
          <img
            class="block md:hidden"
            src="~/assets/images/Te/TeSet/WebengineerJobchange/Support/photo-sp-support.webp"
            alt="サポート内容"
            loading="lazy"
          >
        </div>
      </div>
    </section>

    <!-- 転職サポート -->
    <section
      id="support"
      class="co-bg-striped"
    >
      <div class="co-container-lg px-4 py-20">
        <h2 class="co-heading-2-caption">
          <img
            src="~/assets/images/Te/TeSet/WebengineerJobchange/heading-01.svg"
            alt="01"
            class="mx-auto"
            loading="lazy"
          >
          <span class="block">転職サポート</span>
        </h2>
        <h3 class="co-display-12 mb-[3.25rem] leading-base text-co-gray-600 md:text-center">
          専属のキャリアカウンセラーがあなたの転職が決まるまでサポート。<br class="hidden md:block">サポートはオンライン実施で行うので、お住まいの地方に関係なく転職活動を行えます。
        </h3>
        <div class="mb-10 flex flex-col gap-8 md:flex-row">
          <div>
            <img
              class="mb-5"
              src="~/assets/images/Te/TeSet/WebengineerJobchange/Support/support-photo-1.webp"
              alt="自己分析"
              loading="lazy"
            >
            <h3 class="co-display-10 mb-3 text-center font-bold leading-normal">
              自己分析
            </h3>
            <p class="mb-0 text-co-gray-600">
              自分を知ることで強みと弱みがわかり転職時のアピールポイントが明確になります。
            </p>
          </div>
          <div>
            <img
              class="mb-5"
              src="~/assets/images/Te/TeSet/WebengineerJobchange/Support/support-photo-2.webp"
              alt="書類作成"
              loading="lazy"
            >
            <h3 class="co-display-10 mb-3 text-center font-bold leading-normal">
              書類作成
            </h3>
            <p class="mb-0 text-co-gray-600">
              あなたの魅力を伝え切る、履歴書・職務経歴書の書き方をサポートいたします。
            </p>
          </div>
          <div>
            <img
              class="mb-5"
              src="~/assets/images/Te/TeSet/WebengineerJobchange/Support/support-photo-3.webp"
              alt="カウンセリング"
              loading="lazy"
            >
            <h3 class="co-display-10 mb-3 text-center font-bold leading-normal">
              カウンセリング
            </h3>
            <p class="mb-0 text-co-gray-600">
              キャリアカウンセラーが転職についての質問・相談をオンラインにてお受けいたします。
            </p>
          </div>
        </div>
        <div class="flex flex-col gap-8 md:flex-row">
          <div>
            <img
              class="mb-5"
              src="~/assets/images/Te/TeSet/WebengineerJobchange/Support/support-photo-4.webp"
              alt="面接対策"
              loading="lazy"
            >
            <h3 class="co-display-10 mb-3 text-center font-bold leading-normal">
              面接対策
            </h3>
            <p class="mb-0 text-co-gray-600">
              面接時の受け答えやマナーなど面接時に必要となる対策をサポートいたします。
            </p>
          </div>
          <div>
            <img
              class="mb-5"
              src="~/assets/images/Te/TeSet/WebengineerJobchange/Support/support-photo-5.webp"
              alt="おすすめ求人をご案内"
              loading="lazy"
            >
            <h3 class="co-display-10 mb-3 text-center font-bold leading-normal">
              おすすめ求人をご案内
            </h3>
            <p class="mb-0 text-co-gray-600">
              1000社以上の未経験者向け求人からあなたにマッチする転職先をご案内いたします。
            </p>
          </div>
          <div>
            <img
              class="mb-5"
              src="~/assets/images/Te/TeSet/WebengineerJobchange/Support/support-photo-6.webp"
              alt="企業との一次面接"
              loading="lazy"
            >
            <h3 class="co-display-10 mb-3 text-center font-bold leading-normal">
              企業との一次面接
            </h3>
            <p class="mb-0 text-co-gray-600">
              ほとんどの企業の一次面接はビデオチャットで実施可能です。
            </p>
          </div>
        </div>
      </div>
    </section>

    <!-- 紹介企業 -->
    <section
      id="case"
      class="co-bg-striped"
    >
      <div class="co-container-lg mx-auto px-4 py-20">
        <h2 class="co-heading-2-caption">
          ご紹介企業
        </h2>
        <div class="mb-[3.25rem] text-left text-co-gray-600 md:text-center">
          テックアカデミーで抱える <b>1,000社以上</b> の求人をご案内。
        </div>
        <div class="mb-4 flex flex-wrap justify-center gap-5 md:gap-10 lg:gap-[3.25rem]">
          <div class="bg-white p-1">
            <img
              src="~/assets/images/Te/TeSet/WebengineerJobchange/Company/logo-canon.webp"
              width="180"
              height="52"
              alt="キヤノン"
              loading="lazy"
            >
          </div>
          <div class="bg-white p-1">
            <img
              src="~/assets/images/Te/TeSet/WebengineerJobchange/Company/logo-rakusu.webp"
              width="180"
              height="52"
              alt="ラクス"
              loading="lazy"
            >
          </div>
          <div class="bg-white p-1">
            <img
              src="~/assets/images/Te/TeSet/WebengineerJobchange/Company/logo-seraku.webp"
              width="180"
              height="52"
              alt="SERAKU"
              loading="lazy"
            >
          </div>
          <div class="bg-white p-1">
            <img
              src="~/assets/images/Te/TeSet/WebengineerJobchange/Company/logo-flugel.webp"
              width="180"
              height="52"
              alt="flugel"
              loading="lazy"
            >
          </div>
        </div>
        <div class="co-display-13 mb-[3.25rem] text-center text-co-gray-500">
          ※こちらの企業は一例です
        </div>
        <div class="mb-5 text-center">
          さらに、提携先サービスの求人も合わせてあなたに合った仕事をご紹介。
        </div>
        <img
          src="~/assets/images/Te/TeSet/WebengineerJobchange/Company/image-circus.webp"
          width="600"
          height="426"
          alt="提携先サービス"
          class="mx-auto"
          loading="lazy"
        >
      </div>
    </section>

    <!-- 転職事例 -->
    <section
      id="case"
      class="co-bg-striped"
    >
      <div class="co-container-sm px-4 py-20">
        <h2 class="co-heading-2">
          転職事例
        </h2>
        <div class="mb-10 flex flex-col items-center justify-center gap-7 px-10 md:flex-row md:items-start md:px-0">
          <div>
            <img
              class="mb-5"
              src="~/assets/images/Te/TeSet/WebengineerJobchange/Case/case-01.webp"
              alt="木島 恭平さん"
              loading="lazy"
            >
            <h4 class="co-display-12 mb-2 font-bold leading-normal">
              スキルとIT業界の知識を学び
            </h4>
            <h3 class="co-display-7 mb-7 font-bold leading-normal">
              地方に住みながら<br>最短で転職に成功
            </h3>
            <p class="co-display-13 mb-0 text-co-gray-600">
              木島 恭平さん<br>元カスタマーサポート
            </p>
          </div>
          <div>
            <img
              class="mb-5"
              src="~/assets/images/Te/TeSet/WebengineerJobchange/Case/case-02.webp"
              alt="宝元 眞也さん"
              loading="lazy"
            >
            <h4 class="co-display-12 mb-2 font-bold leading-normal">
              フリーランスを見据えて転職
            </h4>
            <h3 class="co-display-7 mb-7 font-bold leading-normal">
              現役エンジニアの<br>アドバイスを受けて<br>転職に成功
            </h3>
            <p class="co-display-13 mb-0 text-co-gray-600">
              宝元 眞也さん<br>元メーカー技術職
            </p>
          </div>
          <div>
            <img
              class="mb-5"
              src="~/assets/images/Te/TeSet/WebengineerJobchange/Case/case-03.webp"
              alt="小松屋 聡さん"
              loading="lazy"
            >
            <h4 class="co-display-12 mb-2 font-bold leading-normal">
              働きながら転職に成功
            </h4>
            <h3 class="co-display-7 mb-7 font-bold leading-normal">
              30歳の未経験から<br>エンジニアに<br>キャリアチェンジ
            </h3>
            <p class="co-display-13 mb-0 text-co-gray-600">
              小松屋 聡さん<br>元飲料メーカー 営業職
            </p>
          </div>
        </div>
        <h3 class="co-display-6 mb-5 text-center font-bold leading-normal tracking-normal">
          年収アップ実例
        </h3>
        <div class="co-container-xs px-1">
          <img
            class="mb-2 hidden w-full md:block"
            src="~/assets/images/Te/TeSet/WebengineerJobchange/Case/banner-annual-income-pc.webp"
            alt="転職後の年収アップ金額、平均28万円アップ"
            height="116"
            loading="lazy"
          >
          <div class="block text-center md:hidden">
            <img
              class="mb-2"
              src="~/assets/images/Te/TeSet/WebengineerJobchange/Case/banner-annual-income-sp.webp"
              alt="転職後の年収アップ金額、平均28万円アップ"
              height="182"
              loading="lazy"
            >
          </div>
          <p class="co-display-13 mb-2 text-co-gray-600">
            プログラミングを学習し、転職サポートを受けてWebエンジニアになられた多くの方が年収アップを実現しています。
          </p>
          <p class="co-display-14 mb-4 text-co-gray-500">
            ※2023年6月から2024年5月までにエンジニア転職が決定した方の実績です
          </p>
        </div>
      </div>
    </section>

    <!-- 転職保証 -->
    <section
      id="guarantee"
      class="co-bg-striped"
    >
      <div class="co-container-sm px-4 py-[3.25rem]">
        <h2 class="co-heading-2-caption">
          転職保証制度
        </h2>
        <h3 class="co-display-12 mb-[3.25rem] leading-base text-co-gray-600 md:text-center">
          一人ひとりのスキル・適性・ご希望に合わせ、キャリアカウンセラーが徹底して転職をサポートいたします。<br class="hidden md:block">万が一、転職が決まらなかった場合は、受講料を全額返金を保証いたします。
        </h3>
        <h4 class="co-display-10 mb-4 font-bold leading-normal">
          保証条件
        </h4>
        <div class="mb-8 flex flex-col gap-10 md:flex-row">
          <ul class="list-outside list-disc pl-10 text-co-gray-600">
            <li>受講開始時点で20歳以上34歳以下の方</li>
            <li>新卒での就職ではなく転職を検討されている方</li>
            <li>東京での勤務が可能な方</li>
            <li>IT企業へエンジニアとして転職の意思がある方</li>
            <li>受講期間中から修了後6ヶ月間は転職活動をする意思がある方</li>
          </ul>
          <ul class="list-outside list-disc pl-10 text-co-gray-600">
            <li>期間中に学習時間を320時間以上確保できる方</li>
            <li>マンツーマンメンタリングを全て欠席なく実施</li>
            <li>12週間までにPHP/Laravelコースの全課題が終了した方</li>
            <li>24週間までにフロントエンドコースの全課題が終了した方</li>
            <li>企業面接設定後に無断キャンセルがない方</li>
            <li>応募した企業からの面接依頼に必ず回答する方</li>
          </ul>
        </div>
        <h4 class="co-display-10 mb-4 font-bold leading-normal">
          保証内容
        </h4>
        <ul class="mb-8 list-outside list-disc pl-10 text-co-gray-600">
          <li>キャリアカウンセラーがカウンセリング(1回30分)を行い転職をサポートします</li>
          <li>学習プログラム修了後、6ヶ月間内定が出るまで企業面談を実施</li>
          <li>面談を実施しても内定が出ない場合、受講料を全額返金</li>
        </ul>
        <div class="co-gray-600">
          ※ 就業にあたり配慮が必要な事情がある方は、転職支援を受けられない可能性がありますので、事前にご相談ください。
        </div>
      </div>
    </section>

    <!-- CTA -->
    <!-- 251202導線削除 -->
    <!-- <TeCommonBannerFreeTrial id="cta-second">
      <template #counselingLead>
        転職サポートについてご不明点はございませんか？
      </template>
    </TeCommonBannerFreeTrial> -->

    <!-- 挫折させないパーソナルメンターサポート -->
    <section
      id="mentor-support"
      class="co-bg-striped"
    >
      <div class="co-container-lg px-4 pt-20">
        <h2 class="co-heading-2-caption">
          <img
            src="~/assets/images/Te/TeSet/WebengineerJobchange/heading-02.svg"
            alt="02"
            class="mx-auto"
            loading="lazy"
          >
          <span class="block">学習サポート</span>
        </h2>
        <h3 class="co-display-12 mb-[3.25rem] text-left leading-base text-co-gray-600 md:text-center">
          学習時の「わからない」「続かない」を解消し、挫折をなくします。
          <br class="hidden md:block">
          実務で培った技術とノウハウで受講生一人ひとりをサポートします。
        </h3>
        <div class="flex flex-col justify-center gap-x-8 sm:px-36 lg:flex-row lg:px-0">
          <TeCommonMentorSupportMentoring />

          <TeCommonMentorSupportChatSupport />

          <TeCommonMentorSupportIssueReview />
        </div>
      </div>

      <TeCommonMentorSupportMentor>
        <template #mentorImage1>
          <img
            class="size-full object-cover"
            src="~/assets/images/Te/TeCommon/MentorSupport/Mentor/mentor-suda.jpg"
            alt="Hiroshi Suda"
            width="213"
            height="213"
            loading="lazy"
          >
        </template>
        <template #mentorName1>
          Hiroshi
          <br>
          Suda
        </template>
        <template #mentorProfile1>
          IT業界のキャリアは35年以上。対応言語は、C,C#,Javaなど。現在フリーとして受託開発とプログラミング教育に携わる。プログラミング言語は世界で共通言語でありグローバルな視野を持つことをモットーにしています。
        </template>
        <template #mentorMessage1>
          「現在のプログラミングの問題点を捕らえ進化を愉しむための方法」や「プログラムを好きでたまらなくなる方法」など、IT業界を身近に感じてもらうようにサポートさせていただきます。
        </template>
        <template #mentorImage2>
          <img
            class="size-full object-cover"
            src="~/assets/images/Te/TeCommon/MentorSupport/Mentor/mentor-hachiya.jpg"
            alt="Satoshi Hachiya"
            width="213"
            height="213"
            loading="lazy"
          >
        </template>
        <template #mentorName2>
          Satoshi
          <br>
          Hachiya
        </template>
        <template #mentorProfile2>
          Javaプログラマー・NW保守を経て、現在はウェブサイトの運用保守チームで開発サポートと分析業務に携わっています。
        </template>
        <template #mentorMessage2>
          「わからない」を知り、理解しながら学習を進めて頂けるようサポートいたします。学ぶことを楽しみながら、実践的なスキルを身につけましょう！
        </template>
      </TeCommonMentorSupportMentor>

      <TeCommonMentorSupportReason />
    </section>

    <!-- CTA -->
    <!-- 251202導線削除 -->
    <!-- <TeCommonBannerFreeTrial id="cta-third">
      <template #counselingLead>
        学習サポートについてご不明点はございませんか？
      </template>
    </TeCommonBannerFreeTrial> -->

    <!-- 学習内容 -->
    <section
      id="mentor-support"
      class="co-bg-striped pt-20"
    >
      <h2 class="co-heading-2-caption">
        学習内容
      </h2>
      <h3 class="co-display-12 px-4 leading-base text-co-gray-600 md:text-center">
        プログラミング未経験からでも、オリジナルのWebサービスを作成するスキルを習得し、
        <br class="hidden md:block">
        幅広いWebエンジニアスキルを身につけて転職を目指します。
      </h3>
      <!-- PHP/Laravel -->
      <TeSetOutputRigthtPhp class="!bg-inherit" />

      <!-- フロントエンド -->
      <TeSetOutputLeftFrontend class="!bg-inherit" />
    </section>

    <!-- 身につくスキル -->
    <section
      id="skill"
      class="co-bg-striped text-center"
    >
      <div class="co-container-md px-4 py-20">
        <h2 class="co-heading-2-caption">
          身につくスキル
        </h2>
        <p class="co-display-12 mb-[3.25rem] text-left md:text-center">
          Webアプリケーションに関するスキルとWebサイトの表現力を上げるスキルを<br class="hidden md:block">まとめて学べます。
        </p>
        <div class="grid grid-cols-1 gap-y-12 sm:grid-cols-2 sm:gap-x-8 lg:grid-cols-3">
          <TeSetSkill>
            <template #icon>
              <img
                src="~/assets/images/Te/TeSet/Skill/curriculum-php.png"
                alt="PHP/Laravel"
              >
            </template>
            <template #name>
              PHP/Laravel
            </template>
            <template #discription>
              Laravelというフレームワークを学習
            </template>
          </TeSetSkill>
          <TeSetSkill>
            <template #icon>
              <img
                src="~/assets/images/Te/TeSet/Skill/curriculum-github.png"
                alt="Git/GitHub"
              >
            </template>
            <template #name>
              Git/GitHub
            </template>
            <template #discription>
              バージョン管理システムの学習
            </template>
          </TeSetSkill>
          <TeSetSkill>
            <template #icon>
              <FontAwesomeIcon
                :icon="faHtml5"
                class="text-[#e6491c]"
              />
            </template>
            <template #name>
              HTML/CSS3
            </template>
            <template #discription>
              ブラウザに表示させるためのコーディング
            </template>
          </TeSetSkill>
          <TeSetSkill>
            <template #icon>
              <img
                src="~/assets/images/Te/TeSet/Skill/curriculum-tailwindcss.svg"
                alt="Tailwind CSS"
              >
            </template>
            <template #name>
              Tailwind CSS
            </template>
            <template #discription>
              素早くデザインが整ったサイトを作成できるフレームワーク
            </template>
          </TeSetSkill>
          <TeSetSkill>
            <template #icon>
              <FontAwesomeIcon
                :icon="faDatabase"
                class="fa-fw inline size-12 text-co-primary-500"
              />
            </template>
            <template #name>
              SQL
            </template>
            <template #discription>
              データベースを操作するための言語を学習
            </template>
          </TeSetSkill>
          <TeSetSkill>
            <template #icon>
              <FontAwesomeIcon
                :icon="faServer"
                class="fa-fw inline size-12"
              />
            </template>
            <template #name>
              Heroku
            </template>
            <template #discription>
              サービスを公開するためのPaaS
            </template>
          </TeSetSkill>
          <TeSetSkill>
            <template #icon>
              <img
                src="~/assets/images/Te/TeSet/Skill/curriculum-js.png"
                alt="JavaScript/jQuery"
              >
            </template>
            <template #name>
              JavaScript/jQuery
            </template>
            <template #discription>
              サイトに様々な機能を付加できるスクリプト
            </template>
          </TeSetSkill>
          <TeSetSkill>
            <template #icon>
              <img
                src="~/assets/images/Te/TeSet/Skill/curriculum-vuejs.png"
                alt="Vue.js"
              >
            </template>
            <template #name>
              Vue.js
            </template>
            <template #discription>
              JavaScript製のフレームワーク
            </template>
          </TeSetSkill>
          <TeSetSkill>
            <template #icon>
              <FontAwesomeIcon
                :icon="faArrowRightArrowLeft"
                class="fa-fw inline size-12 text-co-success-500"
              />
            </template>
            <template #name>
              Web API
            </template>
            <template #discription>
              Ajaxを利用しデータの扱い方を学習
            </template>
          </TeSetSkill>
          <TeSetSkill>
            <template #icon>
              <img
                src="~/assets/images/Te/TeSet/Skill/curriculum-sakura.jpg"
                alt="サーバー"
              >
            </template>
            <template #name>
              サーバー
            </template>
            <template #discription>
              レンタルサーバーを使ってサイト公開
            </template>
          </TeSetSkill>
          <TeSetSkill>
            <template #icon>
              <img
                src="~/assets/images/Te/TeSet/Skill/curriculum-firebase.svg"
                alt="Firebase"
              >
            </template>
            <template #name>
              Firebase
            </template>
            <template #discription>
              サーバ側の機能をクラウドで扱える開発プラットフォーム
            </template>
          </TeSetSkill>
        </div>
      </div>
    </section>

    <!-- 受講スケジュール -->
    <section
      id="mentor-support"
      class="co-bg-striped py-20"
    >
      <h2 class="co-heading-2">
        受講スケジュール
      </h2>
      <div class="te-schedule-wrap mx-auto mb-2">
        <img
          class="mx-4 max-w-fit lg:mx-0"
          src="~/assets/images/Te/TeSet/WebengineerJobchange/Schedule/illust-schedule.svg"
          width="900"
          height="253"
        >
      </div>
      <div class="co-container-sm px-4 lg:px-0">
        <p class="mb-2 text-co-gray-600">
          前半の12週間でPHP/Laravelを学び、後半の12週間でフロントエンドを学びます。転職活動の準備は学習と並行して行います。学習が終了すると本格的な転職活動を行います。
        </p>
        <p class="co-display-14 mb-0 text-co-gray-500">
          ※24週間プランの場合
        </p>
      </div>
    </section>

    <!-- CTA -->
    <!-- 251202導線削除 -->
    <!-- <TeCommonBannerFreeTrial id="cta-fourth">
      <template #counselingLead>
        学習内容についてご不明点はございませんか？
      </template>
    </TeCommonBannerFreeTrial> -->

    <TeCommonCampaign
      :course-name-path="packScreenName"
      :current-promotion="currentPromotion"
    />

    <!-- 料金プラン -->
    <section
      id="price"
      class="co-bg-striped"
    >
      <!-- 無料相談割引コード -->
      <TeCommonBannerTimeLimitCpnCode
        v-if="BannerNameForShowing === 'campaign'"
        :entry-campaign="entryCampaign"
      />

      <div class="co-container-lg px-5 py-20 xl:px-0">
        <h2 class="co-heading-2">
          料金
        </h2>

        <TeCommonPriceTimeLimit
          v-if="BannerNameForShowing === 'discount'"
          :entry-discount-time-limit="entryDiscountTimeLimit"
        />

        <TeSetWebengineerJobchangePriceTable2Columns
          :pack="pack"
          :current-promotion="currentPromotion"
        >
          <template #additionalFees>
            Flickrの有料サブスクリプション（月額10.44ドル（USD）、2025年7月30日時点）への加入が別途必要となります。受講料には含まれませんのでご注意ください。
          </template>
        </TeSetWebengineerJobchangePriceTable2Columns>

        <!-- クラウドローンバナー -->
        <!-- Educareテスト開始、クラウドローンバナーはコメントアウト -->
        <!-- <TeCommonBannerCrowdloan /> -->

        <!-- 早めの申し込み・入金がお得！バナー -->
        <TeCommonPricePreviously />

        <TeCommonPriceParticipationconditions />

        <div class="flex flex-col lg:flex-row">
          <!-- 注意事項 -->
          <TeCommonPricePrecautions>
            <template #preCautionsList>
              <li class="mb-2">
                支払い方法はクレジットカード払い（分割可能）、コンビニ決済、銀行振込、Amazon Pay、PayPayからお選びいただけます。
              </li>
              <li class="mb-2">
                クレジットカード払いは、Visa、Master、JCB、AMEX、Dinersに対応しています。
              </li>
              <li class="mb-2">
                カード分割払いご利用回数（3/5/6/10/12/15/18/20/24）
              </li>
              <li class="mb-2">
                Dinersは分割の支払いが利用できません。
              </li>
              <li class="mb-2">
                コンビニ決済は30万円を超える支払いにはご利用いただけません。
              </li>
              <li class="mb-2">
                50万円を超えるPayPay決済をご利用の際は、本人確認の認証が必要となります。
              </li>
              <li class="mb-2">
                請求書払いをご希望の場合はお申込後、専用のフォームからご申請ください。
              </li>
              <li class="mb-2">
                決済後、専用のフォームから領収書の発行が可能です。
              </li>
              <li class="mb-2">
                学生は25歳以下が対象、学生証の提示が必要です。
              </li>
              <li class="mb-2">
                参加にはウェブカメラ、マイクが必要となります。
              </li>
              <li class="mb-2">
                12/28から1/3はメンターサポート休止期間です。受講期間がサポート休止期間にかかる場合、受講が最大7日間延長されます。
              </li>
            </template>
          </TeCommonPricePrecautions>

          <!-- キャンセルポリシー -->
          <TeCommonPriceCancelPolicy />
        </div>
      </div>
    </section>

    <!-- 先割 -->
    <TeSetSakiwariChoosePlan
      :pack="pack"
    >
      <template #sakiwariStepTwoText>
        プランは16週間プランをお選びください。
      </template>
    </TeSetSakiwariChoosePlan>

    <!-- キャリアアップ支援事業 -->
    <TeCommonCareerUp
      :pack="pack"
      :set16weeks="true"
    />

    <!-- CTA -->
    <!-- 251202導線削除 -->
    <!-- <TeCommonBannerFreeTrial id="cta-fifth">
      <template #counselingLead>
        お支払いに関するご不明点はございませんか？
      </template>
    </TeCommonBannerFreeTrial> -->

    <!-- 受講の流れ -->
    <section
      id="flow"
      class="co-bg-striped"
    >
      <div class="co-container-sm mx-auto px-4 py-20 md:w-3/4 lg:w-1/2">
        <h2 class="co-heading-2">
          受講の流れ
        </h2>
        <TeSetFlow :arrow="true">
          <template #cardHeader>
            お申し込み、お支払い、アカウント発行
          </template>
          <template #cardBody>
            下記フォームより必要事項を記入してお申し込みください。お申し込み後、入金についてのご連絡させていただきます。入金が確認出来次第、アカウントを発行いたしますのでカリキュラムで予習を始めることができます。
          </template>
        </TeSetFlow>
        <TeSetFlow :arrow="true">
          <template #cardHeader>
            学習開始
          </template>
          <template #cardBody>
            開始日からはパーソナルメンターによるサポートが始まります。オンライン上で学習、課題作成、チャットでの質問、パーソナルメンターとのメンタリングを繰り返し行って、短期間でのオリジナルサービスの開発を目指します。
          </template>
        </TeSetFlow>
        <TeSetFlow :arrow="true">
          <template #cardHeader>
            Webアプリケーションを学習
          </template>
          <template #cardBody>
            まず前半でWebアプリケーションについて学習していただきます。HTML/CSSの書き方からPHP/Laravelを使った開発を学習できます。オリジナルサービスのWebサイトの公開を目指します。
          </template>
        </TeSetFlow>
        <TeSetFlow :arrow="true">
          <template #cardHeader>
            フロントエンドを学習
          </template>
          <template #cardBody>
            後半でフロントエンドついて学習していただきます。jQueryでのアニメーション表現からWeb APIの扱い方を学習できます。Webアプリケーションの学習時に作成したオリジナルサービスへリッチな表現を追加しインターネット上に公開することを目指します。
          </template>
        </TeSetFlow>
        <TeSetFlow>
          <template #cardHeader>
            転職活動
          </template>
          <template #cardBody>
            プログラミング学習と並行して転職活動の準備を専属のキャリアカウンセラーと進めていきます。全ての課題をクリアしてから本格的な転職活動を開始します。
          </template>
        </TeSetFlow>
      </div>
    </section>

    <!-- FAQ -->
    <!-- 251202導線削除 -->
    <!-- <section
      id="faq"
      class="co-bg-striped"
    >
      <div class="co-container-lg px-4 py-20">
        <h2 class="co-heading-2">
          FAQ
        </h2>
        <div class="grid grid-cols-1 gap-x-8 gap-y-10 md:grid-cols-2 md:flex-row">
          <TeSetFaq />
          <TeSetFaq>
            <template #question>
              合計どのくらい学習時間が必要ですか？
            </template>
            <template #answer>
              現在の理解度のレベルと進捗スピードによって異なりますが、目安として合計320時間ほどの確保をお願いしております。無駄を省いた学習システムと、メンターへの質問・課題レビューで通常より短期間で成長することが可能です。
            </template>
          </TeSetFaq>
          <TeSetFaq>
            <template #question>
              正社員未経験、IT業界未経験ですが問題ありませんか？
            </template>
            <template #answer>
              問題ありません。Webエンジニア転職保証コースは未経験の方を対象としています。独自のパーソナルメンター制度で転職に必要なスキルを身につけていただき、転職保証付きサポートで企業への転職が決まるまでを一貫してサポートします。
            </template>
          </TeSetFaq>
          <TeSetFaq>
            <template #question>
              全くの初心者ですが問題ありませんか？
            </template>
            <template #answer>
              問題ありません。全くの初心者の方でもIT企業にエンジニアとして転職できるレベルまで、パーソナルメンターが全力でサポートします。ただし、学習時間を確保の上、しっかり自習して学習を進めることが前提です。
            </template>
          </TeSetFaq>
          <TeSetFaq>
            <template #question>
              レンタルサーバーの登録は事前に必要でしょうか？
            </template>
            <template #answer>
              必要ありません。レンタルサーバーの登録方法などはカリキュラムで全てご案内します。また、さくらのレンタルサーバー（スタンダードプラン）を3ヶ月無料で利用できる特典もご用意しているので、受講料以外の追加費用なしでご利用いただけます。
            </template>
          </TeSetFaq>
          <TeSetFaq>
            <template #question>
              転職が決まらない場合はどうなりますか？
            </template>
            <template #answer>
              転職サポートでは受講生一人一人に対し手厚いサポートを行いますが、万が一、学習プログラム修了後6ヶ月経っても転職が決まらない場合にはサポートを終了させていただきます。その際には受講料を全額返金いたします。
            </template>
          </TeSetFaq>
          <TeSetFaq>
            <template #question>
              受講や転職サポートに条件はありますか？
            </template>
            <template #answer>
              転職サポートでは受講生一人一人に対し手厚いサポートを行いますが、万が一、学習プログラム修了後6ヶ月経っても転職が決まらない場合にはサポートを終了させていただきます。その際には受講料を全額返金いたします。
            </template>
          </TeSetFaq>
        </div>
      </div>
    </section> -->

    <!-- 無料相談割引コード -->
    <TeCommonBannerTimeLimitCpnCode
      v-if="BannerNameForShowing === 'campaign'"
      :entry-campaign="entryCampaign"
    />

    <TeSetApply
      :pack="pack"
      :pack-plans="packPlans"
      :current-promotion="currentPromotion"
      :pack-screen-name="packScreenName"
      :entry-campaign="entryCampaign"
    />

    <!-- 下部固定ボタン -->
    <!-- 251202導線削除 -->
    <!-- <TeCommonButtonFixedBottom /> -->
  </div>
</template>

<script lang="ts">
import { scriptTagsByConfig } from '~/utility/scriptTags'
import { metaTags } from '~/utility/constants/metaTags'
import { AdItems } from '~/utility/constants/ad_items'

import TeSetWebengineerJobchangeCover from '~/components/Te/TeSet/WebengineerJobchange/TeSetWebengineerJobchangeCover.vue'
import TeCommonPagenav from '~/components/Te/TeCommon/Pagenav/TeCommonPagenav.vue'
import TeCommonBannerTimeLimitCpnCode from '~/components/Te/TeCommon/Banner/TeCommonBannerTimeLimitCpnCode/TeCommonBannerTimeLimitCpnCode.vue'
import TeCommonBannerSettlement from '~/components/Te/TeCommon/Banner/TeCommonBannerSettlement/TeCommonBannerSettlement.vue'
import TeCommonBannerTimelimit from '~/components/Te/TeCommon/Banner/TeCommonBannerTimelimit/TeCommonBannerTimelimit.vue'
import TeCommonBannerCampaign from '~/components/Te/TeCommon/Banner/TeCommonBannerCampaign/TeCommonBannerCampaign.vue'
import TeSetAbout from '~/components/Te/TeSet/TeSetAbout.vue'
import TeCommonBannerFreeTrial from '~/components/Te/TeCommon/Banner/TeCommonBannerFreeTrial/TeCommonBannerFreeTrial.vue'
import TeCommonMentorSupportMentoring from '~/components/Te/TeCommon/MentorSupport/TeCommonMentorSupportMentoring/TeCommonMentorSupportMentoring.vue'
import TeCommonMentorSupportChatSupport from '~/components/Te/TeCommon/MentorSupport/TeCommonMentorSupportChatSupport/TeCommonMentorSupportChatSupport.vue'
import TeCommonMentorSupportIssueReview from '~/components/Te/TeCommon/MentorSupport/TeCommonMentorSupportIssueReview/TeCommonMentorSupportIssueReview.vue'
import TeCommonMentorSupportMentor from '~/components/Te/TeCommon/MentorSupportMentor/TeCommonMentorSupportMentor.vue'
import TeCommonMentorSupportReason from '~/components/Te/TeCommon/MentorSupport/TeCommonMentorSupportReason/TeCommonMentorSupportReason.vue'
import TeSetOutputRigthtPhp from '~/components/Te/TeSet/Output/TeSetOutputRigthtPhp.vue'
import TeSetOutputLeftFrontend from '~/components/Te/TeSet/Output/TeSetOutputLeftFrontend.vue'
import TeSetSkill from '~/components/Te/TeSet/TeSetSkill.vue'
import TeCommonCampaign from '~/components/Te/TeCommon/TeCommonCampaign/TeCommonCampaign.vue'
import TeCommonPriceTimeLimit from '~/components/Te/TeCommon/Price/TeCommonPriceTimeLimit/TeCommonPriceTimeLimit.vue'
import TeSetWebengineerJobchangePriceTable2Columns from '~/components/Te/TeSet/WebengineerJobchange/TeSetWebengineerJobchangePriceTable2Columns.vue'
import TeCommonPricePreviously from '~/components/Te/TeCommon/Price/TeCommonPricePreviously/TeCommonPricePreviously.vue'
import TeCommonPriceParticipationconditions from '~/components/Te/TeCommon/Price/TeCommonPriceParticipationconditions/TeCommonPriceParticipationconditions.vue'
import TeCommonPricePrecautions from '~/components/Te/TeCommon/Price/TeCommonPricePrecautions/TeCommonPricePrecautions.vue'
import TeCommonBannerCrowdloan from '~/components/Te/TeCommon/Banner/Crowdloan/TeCommonBannerCrowdloan.vue'
import TeCommonPriceCancelPolicy from '~/components/Te/TeCommon/Price/TeCommonPriceCancelPolicy/TeCommonPriceCancelPolicy.vue'
import TeSetSakiwariChoosePlan from '~/components/Te/TeSet/TeSetSakiwariChoosePlan.vue'
import TeCommonCareerUp from '~/components/Te/TeCommon/CareerUp/TeCommonCareerUp.vue'
import TeSetFlow from '~/components/Te/TeSet/TeSetFlow.vue'
import TeSetFaq from '~/components/Te/TeSet/TeSetFaq.vue'
import TeSetApply from '~/components/Te/TeSet/TeSetApply.vue'
import TeCommonButtonFixedBottom from '~/components/Te/TeCommon/Button/TeCommonButtonFixedBottom/TeCommonButtonFixedBottom.vue'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faHtml5 } from '@awesome.me/kit-65d95819ce/icons/classic/brands'
import { faDatabase, faServer, faArrowRightArrowLeft } from '@awesome.me/kit-65d95819ce/icons/classic/solid'

const options = {
  async setup() {
    const route = useRoute()
    const namePath = route.path.split('/')[2]
    const packScreenName = `${namePath}`
    const { pack, packPlans } = usePack(packScreenName)
    const {
      entryDiscountTimeLimit,
      entrySettlementTimeLimit,
      entryPaymentUrl,
      entryCampaign,
      BannerNameForShowing,
    } = useTopTimeLimits()
    const { currentPromotion } = usePromotion()

    return {
      route,
      pack,
      packPlans,
      namePath,
      packScreenName,
      entryDiscountTimeLimit,
      entrySettlementTimeLimit,
      entryPaymentUrl,
      entryCampaign,
      BannerNameForShowing,
      currentPromotion,
      faHtml5,
      faDatabase,
      faServer,
      faArrowRightArrowLeft,
    }
  },
  oldHead() {
    const scriptTags = scriptTagsByConfig({
      useCase: 'set',
      deviceSize: useNuxtApp().$deviceSize,
      karteElement: {
        ad_item_id: AdItems[this.packScreenName].item_id,
        ad_item_price: AdItems[this.packScreenName].price,
      },
    })
    return {
      title: '未経験からのWebエンジニア転職保証コース | テックアカデミー',
      meta: [
        ...metaTags(
          {
            description:
              '【テックアカデミー(TechAcademy)】プログラミング未経験からIT企業へWebエンジニアとして転職を目指せるコース。現役エンジニアのパーソナルメンターが週に2回のマンツーマンメンタリング、毎日のチャットでサポート。',
            twitterTitle: '未経験からのWebエンジニア転職保証コース',
            twitterDescription:
              '【テックアカデミー(TechAcademy)】プログラミング未経験からIT企業へWebエンジニアとして転職を目指せるコース。現役エンジニアのパーソナルメンターが週に2回のマンツーマンメンタリング、毎日のチャットでサポート。',
            twitterImage: '/_nuxt/ogp/te/teset/og-image-webengineer-jobchange.jpg',
            ogTitle: '未経験からのWebエンジニア転職保証コース',
            ogDescription:
              '【テックアカデミー(TechAcademy)】プログラミング未経験からIT企業へWebエンジニアとして転職を目指せるコース。現役エンジニアのパーソナルメンターが週に2回のマンツーマンメンタリング、毎日のチャットでサポート。',
            ogUrl: '/set/webengineer-jobchange',
            ogImage: '/_nuxt/ogp/te/teset/og-image-webengineer-jobchange.jpg',
          },
          process.env.host as string
        ),
      ],
      script: scriptTags!.script,
      noscript: scriptTags!.noscript,
    }
  },
  data() {
    return {
      scriptInfo: {},
      latestCohort: null,
      sakiwariCohorts: [],
      currentPromotion: null,
      firstOpenedWholeCohort: null,
    }
  },
  computed: {},
  methods: {},
  components: {
    TeSetWebengineerJobchangeCover,
    TeCommonPagenav,
    TeCommonBannerTimeLimitCpnCode,
    TeCommonBannerSettlement,
    TeCommonBannerTimelimit,
    TeCommonBannerCampaign,
    TeSetAbout,
    TeCommonBannerFreeTrial,
    TeCommonMentorSupportMentoring,
    TeCommonMentorSupportChatSupport,
    TeCommonMentorSupportIssueReview,
    TeCommonMentorSupportMentor,
    TeCommonMentorSupportReason,
    TeSetOutputRigthtPhp,
    TeSetOutputLeftFrontend,
    TeSetSkill,
    TeCommonCampaign,
    TeCommonPriceTimeLimit,
    TeSetWebengineerJobchangePriceTable2Columns,
    TeCommonBannerCrowdloan,
    TeCommonPricePreviously,
    TeCommonPriceParticipationconditions,
    TeCommonPricePrecautions,
    TeCommonPriceCancelPolicy,
    TeSetSakiwariChoosePlan,
    TeCommonCareerUp,
    TeSetFlow,
    TeSetFaq,
    TeSetApply,
    TeCommonButtonFixedBottom,
    FontAwesomeIcon,
  },
}

export default defineNuxtComponent(options)
</script>

<style scoped>
/* こんな方にオススメです */
.te-bg-set-target {
  background-image: url('~/assets/images/Te/TeSet/WebengineerJobchange/Target/bg-target.webp');
}

.te-target-text {
  font-size: 1rem;
  @media (min-width: 768px) {
    font-size: 1.125rem;
  }
  @media (min-width: 996px) {
    font-size: 1.25rem;
  }
}

/* 受講スケジュール */
.te-schedule-wrap {
  width: 100%;
  overflow-x: scroll;
  @media (min-width: 996px) {
    width: 900px;
  }
}
</style>
